import _ from 'lodash'

/*
 * Similar to the core `selection`, but just holds connectors
 */
function ConnectorsSelection (canvas) {
  this.connectors = []
  this.canvas = canvas
}

ConnectorsSelection.prototype.add = function (connector) {
  if (_.indexOf(this.connectors, connector) >= 0) { return }
  this.connectors.push(connector)
  connector.set('selected', true)
  return this
}

ConnectorsSelection.prototype.remove = function (connector) {
  if (_.indexOf(this.connectors, connector) < 0) { return }
  connector.set('selected', false)
  connector.trigger('change:configurable', connector, false) // It can't be configured if it's not selected

  var index = this.connectors.indexOf(connector)
    , connectors = this.connectors.slice()
  connectors.splice(index, 1)
  this.connectors = connectors
  return this
}

ConnectorsSelection.prototype.clear = function () {
  this.connectors.forEach(connector => this.remove(connector))
}

ConnectorsSelection.prototype.release = function () {
  this.connectors = []
}

export default ConnectorsSelection
